var isWin = process.platform === 'win32';
var SEP = isWin ? "\\\\+" : "\\/";
var SEP_ESC = isWin ? "\\\\" : "/";
var GLOBSTAR = "((?:[^/]*(?:/|$))*)";
var WILDCARD = "([^/]*)";
var GLOBSTAR_SEGMENT = "((?:[^".concat(SEP_ESC, "]*(?:").concat(SEP_ESC, "|$))*)");
var WILDCARD_SEGMENT = "([^".concat(SEP_ESC, "]*)");
/**
 * Convert any glob pattern to a JavaScript Regexp object
 * @param {String} glob Glob pattern to convert
 * @param {Object} opts Configuration object
 * @param {Boolean} [opts.extended=false] Support advanced ext globbing
 * @param {Boolean} [opts.globstar=false] Support globstar
 * @param {Boolean} [opts.strict=true] be laissez faire about mutiple slashes
 * @param {Boolean} [opts.filepath=''] Parse as filepath for extra path related features
 * @param {String} [opts.flags=''] RegExp globs
 * @returns {Object} converted object with string, segments and RegExp object
 */

function globrex(glob) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$extended = _ref.extended,
      extended = _ref$extended === void 0 ? false : _ref$extended,
      _ref$globstar = _ref.globstar,
      globstar = _ref$globstar === void 0 ? false : _ref$globstar,
      _ref$strict = _ref.strict,
      strict = _ref$strict === void 0 ? false : _ref$strict,
      _ref$filepath = _ref.filepath,
      filepath = _ref$filepath === void 0 ? false : _ref$filepath,
      _ref$flags = _ref.flags,
      flags = _ref$flags === void 0 ? '' : _ref$flags;

  var regex = '';
  var segment = '';
  var path = {
    regex: '',
    segments: []
  }; // If we are doing extended matching, this boolean is true when we are inside
  // a group (eg {*.html,*.js}), and false otherwise.

  var inGroup = false;
  var inRange = false; // extglob stack. Keep track of scope

  var ext = []; // Helper function to build string and segments

  function add(str) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        split = _ref2.split,
        last = _ref2.last,
        only = _ref2.only;

    if (only !== 'path') regex += str;

    if (filepath && only !== 'regex') {
      path.regex += str === '\\/' ? SEP : str;

      if (split) {
        if (last) segment += str;

        if (segment !== '') {
          if (!flags.includes('g')) segment = "^".concat(segment, "$"); // change it 'includes'

          path.segments.push(new RegExp(segment, flags));
        }

        segment = '';
      } else {
        segment += str;
      }
    }
  }

  var c, n;

  for (var i = 0; i < glob.length; i++) {
    c = glob[i];
    n = glob[i + 1];

    if (['\\', '$', '^', '.', '='].includes(c)) {
      add("\\".concat(c));
      continue;
    }

    if (c === '/') {
      add("\\".concat(c), {
        split: true
      });
      if (n === '/' && !strict) regex += '?';
      continue;
    }

    if (c === '(') {
      if (ext.length) {
        add(c);
        continue;
      }

      add("\\".concat(c));
      continue;
    }

    if (c === ')') {
      if (ext.length) {
        add(c);
        var type = ext.pop();

        if (type === '@') {
          add('{1}');
        } else if (type === '!') {
          add('([^\/]*)');
        } else {
          add(type);
        }

        continue;
      }

      add("\\".concat(c));
      continue;
    }

    if (c === '|') {
      if (ext.length) {
        add(c);
        continue;
      }

      add("\\".concat(c));
      continue;
    }

    if (c === '+') {
      if (n === '(' && extended) {
        ext.push(c);
        continue;
      }

      add("\\".concat(c));
      continue;
    }

    if (c === '@' && extended) {
      if (n === '(') {
        ext.push(c);
        continue;
      }
    }

    if (c === '!') {
      if (extended) {
        if (inRange) {
          add('^');
          continue;
        }

        if (n === '(') {
          ext.push(c);
          add('(?!');
          i++;
          continue;
        }

        add("\\".concat(c));
        continue;
      }

      add("\\".concat(c));
      continue;
    }

    if (c === '?') {
      if (extended) {
        if (n === '(') {
          ext.push(c);
        } else {
          add('.');
        }

        continue;
      }

      add("\\".concat(c));
      continue;
    }

    if (c === '[') {
      if (inRange && n === ':') {
        i++; // skip [

        var value = '';

        while (glob[++i] !== ':') {
          value += glob[i];
        }

        if (value === 'alnum') add('(\\w|\\d)');else if (value === 'space') add('\\s');else if (value === 'digit') add('\\d');
        i++; // skip last ]

        continue;
      }

      if (extended) {
        inRange = true;
        add(c);
        continue;
      }

      add("\\".concat(c));
      continue;
    }

    if (c === ']') {
      if (extended) {
        inRange = false;
        add(c);
        continue;
      }

      add("\\".concat(c));
      continue;
    }

    if (c === '{') {
      if (extended) {
        inGroup = true;
        add('(');
        continue;
      }

      add("\\".concat(c));
      continue;
    }

    if (c === '}') {
      if (extended) {
        inGroup = false;
        add(')');
        continue;
      }

      add("\\".concat(c));
      continue;
    }

    if (c === ',') {
      if (inGroup) {
        add('|');
        continue;
      }

      add("\\".concat(c));
      continue;
    }

    if (c === '*') {
      if (n === '(' && extended) {
        ext.push(c);
        continue;
      } // Move over all consecutive "*"'s.
      // Also store the previous and next characters


      var prevChar = glob[i - 1];
      var starCount = 1;

      while (glob[i + 1] === '*') {
        starCount++;
        i++;
      }

      var nextChar = glob[i + 1];

      if (!globstar) {
        // globstar is disabled, so treat any number of "*" as one
        add('.*');
      } else {
        // globstar is enabled, so determine if this is a globstar segment
        var isGlobstar = starCount > 1 && ( // multiple "*"'s
        prevChar === '/' || prevChar === undefined) && ( // from the start of the segment
        nextChar === '/' || nextChar === undefined); // to the end of the segment

        if (isGlobstar) {
          // it's a globstar, so match zero or more path segments
          add(GLOBSTAR, {
            only: 'regex'
          });
          add(GLOBSTAR_SEGMENT, {
            only: 'path',
            last: true,
            split: true
          });
          i++; // move over the "/"
        } else {
          // it's not a globstar, so only match one path segment
          add(WILDCARD, {
            only: 'regex'
          });
          add(WILDCARD_SEGMENT, {
            only: 'path'
          });
        }
      }

      continue;
    }

    add(c);
  } // When regexp 'g' flag is specified don't
  // constrain the regular expression with ^ & $


  if (!flags.includes('g')) {
    regex = "^".concat(regex, "$");
    segment = "^".concat(segment, "$");
    if (filepath) path.regex = "^".concat(path.regex, "$");
  }

  var result = {
    regex: new RegExp(regex, flags)
  }; // Push the last segment

  if (filepath) {
    path.segments.push(new RegExp(segment, flags));
    path.regex = new RegExp(path.regex, flags);
    path.globstar = new RegExp(!flags.includes('g') ? "^".concat(GLOBSTAR_SEGMENT, "$") : GLOBSTAR_SEGMENT, flags);
    result.path = path;
  }

  return result;
}

module.exports = globrex;